// Handle both Vite (browser/build) and Node.js (test) environments
export const BASE_PATH = (() => {
  // Check if we're in a Node.js environment (where process is defined and window is not)
  if (typeof process !== "undefined" && typeof window === "undefined") {
    return process.env.BASE_URL || "/";
  }

  // In Vite/browser environment, use dynamic evaluation to avoid syntax errors
  try {
    return import.meta.env.BASE_URL;
  } catch {
    return "/";
  }
})();

export const getPath = (path: string) => `${BASE_PATH}/${path}`.replace(/\/+/g, "/");

/** Absolute URL of an app path. Resolved, not concatenated: Storybook builds with base "./". */
export const getUrl = (path: string) =>
  new URL(getPath(path), window.location.href).href;
